import React from "react";
import DefaultFallbackComponent from "./DefaultFallbackComponent";
import logHandler from "web/core/logs/logHandler";
import { withRouter } from "react-router";

class ErrorBoundary extends React.Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
      error: null,
      info: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.hasError && nextProps.location !== this.props.location) {
      this.setState((state) => ({ hasError: false }));
    }
  }

  componentDidCatch(error, info) {
    const { onError } = this.props;

    if (typeof onError === "function") {
      onError.call(this, error, info ? info.componentStack : "");
    }

    if (!process.env.SERVER) {
      logHandler.getLogger().error(error);
    }

    this.setState((state) => ({ hasError: true, error, info }));
  }

  render() {
    const { hasError, error, info } = this.state;
    return this.props.children({
      hasError,
      error,
      componentStack: info ? info.componentStack : "",
    });
  }
}

export const withHideOnErrorBoundary = (BaseComponent) => (props) =>
  (
    <ErrorBoundary>
      {({ hasError }) => {
        return hasError ? null : <BaseComponent {...props} />;
      }}
    </ErrorBoundary>
  );

export const withErrorBoundary =
  (FallbackComponent = DefaultFallbackComponent) =>
  (BaseComponent) =>
  (props) => {
    return (
      <ErrorBoundary>
        {({ hasError, error, componentStack }) => {
          return hasError ? (
            <FallbackComponent error={error} componentStack={componentStack} />
          ) : (
            <BaseComponent {...props} />
          );
        }}
      </ErrorBoundary>
    );
  };

export default withRouter(ErrorBoundary);
